export default __webpack_public_path__ + "static/media/Una_9781408315958.24c6ea2e.jpg";